import React from 'react';
import { useSurvey } from './Context';

const QuestionNavigateBtn = ({ isNext = true }) => {
    const { goToNextQuestion, goToPreviousQuestion } = useSurvey();

    const handleNavigation = () => {
        window.dataLayer.push({
            event: 'survey_question_navigate_click',
            value: isNext ? 'next' : 'previous',
            page: window.location.pathname,
        });

        if (isNext) {
            goToNextQuestion();
        } else {
            goToPreviousQuestion();
        }
    };

    const className = `question-control ${isNext ? 'next-control' : 'prev-control'}`;
    return (
        <button className={className} onClick={handleNavigation}>
            {!isNext && (
                <>
                    <span className="sr-only">Previous Question</span>
                    <svg className="control-icon" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M6.41701 12.2695L9.05816 12.2695L6.74635 9.00846L8.63842 9.00846L12.0674 9.00846L12.0674 6.77414L8.63842 6.77414L6.74635 6.77414L9.05816 3.51953L6.41701 3.51953L3.31738 7.8913L6.41701 12.2695Z" />
                    </svg>
                </>
            )}

            {isNext && (
                <>
                    <span className="sr-only">Next Question</span>
                    <svg className="control-icon" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M8.27537 3.51953H5.63422L7.94603 6.7806H6.05397H2.625V9.01492H6.05397H7.94603L5.63422 12.2695H8.27537L11.375 7.89776L8.27537 3.51953Z" />
                    </svg>
                </>
            )}
        </button>
    );
};

export default QuestionNavigateBtn;
